"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = __importDefault(require("./index"));
const getValue = (ast, data) => ast.value !== undefined ? ast.value : (0, index_1.default)({ ast, data });
const booleanNums = {
    [true]: 1,
    [false]: 0,
};
// TODO: This parseFloat may not be necessary. Need to keep an eye
// on how data is represented, double check if string conversion is
// necessary in practice
const getFloatValue = (ast, data) => {
    const value = getValue(ast, data);
    return parseFloat(typeof value === 'boolean' ? booleanNums[value] : value);
};
const getStringValue = (ast, data) => {
    const value = getValue(ast, data);
    return value != null ? value.toString() : '';
};
const equal = ({ ast: { left, right }, data }) => getStringValue(left, data) === getStringValue(right, data);
const notEqual = args => !equal(args);
const multiply = ({ ast: { left, right }, data }) => getFloatValue(left, data) * getFloatValue(right, data);
const divide = ({ ast: { left, right }, data }) => getFloatValue(left, data) / getFloatValue(right, data);
const add = ({ ast: { left, right }, data }) => getFloatValue(left, data) + getFloatValue(right, data);
const subtract = ({ ast: { left, right }, data }) => getFloatValue(left, data) - getFloatValue(right, data);
const lessThan = ({ ast: { left, right }, data }) => getFloatValue(left, data) < getFloatValue(right, data);
const lessThanOrEqual = ({ ast: { left, right }, data }) => getFloatValue(left, data) <= getFloatValue(right, data);
const greaterThan = ({ ast: { left, right }, data }) => getFloatValue(left, data) > getFloatValue(right, data);
const greaterThanOrEqual = ({ ast: { left, right }, data }) => getFloatValue(left, data) >= getFloatValue(right, data);
const or = ({ ast: { left, right }, data }) => !!(getValue(left, data) || getValue(right, data));
const and = ({ ast: { left, right }, data }) => !!(getValue(left, data) && getValue(right, data));
const throwMissingOpError = op => {
    const error = new Error(`Missing operator: ${op}`);
    throw error;
};
const operatorMap = op => ({
    or,
    and,
    '==': equal,
    '!=': notEqual,
    '*': multiply,
    '+': add,
    '-': subtract,
    div: divide,
    '/': divide,
    '<': lessThan,
    '<=': lessThanOrEqual,
    '>': greaterThan,
    '>=': greaterThanOrEqual,
}[op] || (() => throwMissingOpError(op)));
const operatorFn = (ast, data) => {
    const { operator } = ast;
    return operatorMap(operator)({ ast, data });
};
exports.default = operatorFn;
//# sourceMappingURL=execute-operator.js.map